import * as React from 'react';
import Text from 'components/Text';
import Row from 'components/Row';
import Heading from 'components/Heading';
import Radio from 'components/Radio';

import { Mutation } from 'react-apollo';
import SET_CLASS_PARTICIPANT_MESSAGING from 'groups/components/mutations/setParticipantMessaging.gql';
import ToastActions from 'actions/ToastActions';
import { ApolloError } from 'apollo-client';
import { setParticipantMessagingVariables } from 'groups/components/mutations/__generated__/setParticipantMessaging';

type Props = {
  groupUuid: string;
  participantMessagingSchoolDefault: string;
  participantMessaging: string;
  participantMessagingSelect: (setParticipantMessaging: Function, option: string) => void;
};
const GroupOptionsParticipantMessagingSelect = (props: Props) => (
  <Mutation
    mutation={SET_CLASS_PARTICIPANT_MESSAGING}
    onCompleted={() => ToastActions.showSuccessToast('Saved')}
    onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
    {(
      setParticipantMessaging: (input: { variables: setParticipantMessagingVariables }) => void
    ) => (
      <Row>
        <Heading data-test="GroupOptionsCheckbox-title" level="3" levelStyle="5" align="left">
          Participant messaging
        </Heading>
        <Text
          data-test="GroupOptionsCheckbox-sublabel"
          element="div"
          color="graphite"
          size="xsmall">
          Choose how participants see and message others in the class.
        </Text>
        {props.participantMessagingSchoolDefault && (
          <Text
            data-test="GroupOptionsCheckbox-schoolDefault"
            element="div"
            color="graphite"
            size="xsmall"
            italic
            lineHeight="xlarge">
            School default: {props.participantMessagingSchoolDefault}
          </Text>
        )}
        <Row>
          <Radio
            data-test="GroupOptionsRadioSelect-option"
            label="On"
            labelNote="All participants in the class can message each other."
            checked={props.participantMessaging === 'open'}
            onChange={() => {
              props.participantMessagingSelect(setParticipantMessaging, 'open');
            }}
          />
          <Radio
            data-test="GroupOptionsRadioSelect-option"
            label="Role-based"
            labelNote="Students can only message students; parents can only message parents."
            checked={props.participantMessaging === 'ownerOrSameRole'}
            onChange={() => {
              props.participantMessagingSelect(setParticipantMessaging, 'ownerOrSameRole');
            }}
          />
          <Radio
            data-test="GroupOptionsRadioSelect-option"
            label="Off"
            labelNote="Participants can only message class owners and can’t see others in the class."
            checked={props.participantMessaging === 'ownersOnly'}
            onChange={() => {
              props.participantMessagingSelect(setParticipantMessaging, 'ownersOnly');
            }}
          />
        </Row>
      </Row>
    )}
  </Mutation>
);

export default GroupOptionsParticipantMessagingSelect;
